import React, { useState, useEffect, useRef } from "react";
import QRCodeLib from "qrcode";
import api from "../api/homeapi";
import { useNavigate } from "react-router-dom";
import { downloadTicketsPdf, ticketFromBooking } from "../utils/ticketPdf";
import { useSettings } from "../context/SettingsContext";
import { formatDateFR } from "../utils/format";
import PublicNav from "../components/PublicNav";
import { useShowToast, InlineAlert } from "../components/Notify";

/* ═══════════════════════════════════════
   COULEURS SETRAG
═══════════════════════════════════════ */
const C = {
  green:    "#006B3C",
  greenDk:  "#004D2B",
  greenLt:  "#E8F5EE",
  greenMd:  "#C8E6D4",
  yellow:   "#FFC300",
  yellowLt: "#FFF8DC",
  white:    "#FFFFFF",
  gray:     "#F5F5F5",
  grayBd:   "#E0E0E0",
  text:     "#1A1A1A",
  textSub:  "#666666",
};

/* ═══════════════════════════════════════
   ICONS - tous en SVG stroke, poids 1.7
═══════════════════════════════════════ */
const Icon = ({ d, size = 16, ...props }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" {...props}>
    {Array.isArray(d) ? d.map((p, i) => <path key={i} d={p} />) : <path d={d} />}
  </svg>
);

const MapPinIcon    = ({ size }) => <Icon size={size||14} d={["M12 2a5 5 0 015 5c0 4.5-5 11-5 11S7 11.5 7 7a5 5 0 015-5z","M12 9.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"]} />;
const CalIcon       = ({ size }) => <Icon size={size||14} d={["M4 5h16a1 1 0 011 1v13a1 1 0 01-1 1H4a1 1 0 01-1-1V6a1 1 0 011-1z","M16 3v4M8 3v4M3 9h18"]} />;
const SearchIcon    = ({ size }) => <Icon size={size||16} d={["M11 19a8 8 0 100-16 8 8 0 000 16z","M21 21l-4.35-4.35"]} />;
const SeatIcon      = ({ size }) => <Icon size={size||14} d={["M5 11V6a2 2 0 012-2h10a2 2 0 012 2v5M3 15h18v4H3zM7 19v2M17 19v2"]} />;
const ArrowIcon     = ({ size }) => <Icon size={size||14} d={["M4 12h16","M13 6l6 6-6 6"]} />;
const HamburgerIcon = ({ size }) => <Icon size={size||22} d={["M4 6h16M4 12h16M4 18h16"]} />;
const PrintIcon     = ({ size }) => <Icon size={size||15} d={["M6 9V4h12v5","M6 18H4a2 2 0 01-2-2v-5a2 2 0 012-2h16a2 2 0 012 2v5a2 2 0 01-2 2h-2","M6 14h12v6H6z"]} />;
const TrainIcon     = ({ size }) => <Icon size={size||20} d={["M4 4h16a2 2 0 012 2v9a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2z","M8 17l-2 3","M16 17l2 3","M2 11h20","M9 4v7","M15 4v7"]} />;
const UsersIcon     = ({ size }) => <Icon size={size||14} d={["M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2","M9 11a4 4 0 100-8 4 4 0 000 8z","M23 21v-2a4 4 0 00-3-3.87","M16 3.13a4 4 0 010 7.75"]} />;
const ReturnIcon    = ({ size }) => <Icon size={size||14} d={["M4 12h14a4 4 0 010 8h-4","M4 12l4-4M4 12l4 4"]} />;
const FlagIcon      = ({ size }) => <Icon size={size||16} d={["M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z","M4 22v-7"]} />;
const TrainCarIcon  = ({ size }) => <Icon size={size||22} d={["M3 5h18a1 1 0 011 1v10a1 1 0 01-1 1H3a1 1 0 01-1-1V6a1 1 0 011-1z","M7 17l-2 3","M17 17l2 3","M3 11h18","M8 5v6","M16 5v6"]} />;
const StarIcon      = ({ size }) => <Icon size={size||22} d={["M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"]} />;
const CrownIcon     = ({ size }) => <Icon size={size||22} d={["M2 19h20M3 19L2 8l5 5 5-8 5 8 5-5-1 11H3z"]} />;
const CheckIcon     = ({ size }) => <Icon size={size||16} d="M5 13l4 4L19 7" />;
const TicketIcon    = ({ size }) => <Icon size={size||20} d={["M14 5H3a1 1 0 00-1 1v4a2 2 0 010 4v4a1 1 0 001 1h11M14 5h7a1 1 0 011 1v4a2 2 0 000 4v4a1 1 0 01-1 1h-7M14 5v14"]} />;

// Icônes footer - propres, même style trait fin
const PhoneIcon = ({ size = 16, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.6 21 3 13.4 3 4c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1L6.6 10.8z"/>
  </svg>
);

const EmailIcon = ({ size = 16, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="4" width="20" height="16" rx="2"/>
    <path d="M2 7l10 7 10-7"/>
  </svg>
);

const CLASS_INFO = {
  ECONOMIQUE: { label: "Économique",      color: "#006B3C", bg: "#E8F5EE", Icon: TrainCarIcon },
  PREMIERE:   { label: "1ère Classe",     color: "#004D2B", bg: "#C8E6D4", Icon: StarIcon    },
  VIP:        { label: "VIP / Couchette", color: "#FFC300", bg: "#FFF8DC", Icon: CrownIcon   },
};

/* ═══════════════════════════════════════
   QR CODE
═══════════════════════════════════════ */
const QRCode = ({ data, size = 80 }) => {
  const canvasRef = useRef(null);
  useEffect(() => {
    if (!canvasRef.current || !data) return;
    QRCodeLib.toCanvas(canvasRef.current, data, {
      width: size,
      color: { dark: "#004D2B", light: "#ffffff" },
      errorCorrectionLevel: "H",
    }).catch(() => {});
  }, [data, size]);
  return <canvas ref={canvasRef} width={size} height={size} />;
};

const buildQRDataURL = async (text, size = 80) =>
  QRCodeLib.toDataURL(text, { width: size, color: { dark: "#004D2B", light: "#ffffff" }, errorCorrectionLevel: "H" });

const buildQRPayload = (booking, passenger, trip, cls, tripType = "ALLER") => JSON.stringify({
  ref: booking?.reference || "", nom: passenger.fullName, siege: passenger.seatNumber,
  depart: trip.departure?.name, arrivee: trip.arrival?.name, date: trip.date,
  heure: trip.departureTime, train: trip.trainNumber, classe: cls.label,
  prix: trip.price, type: tripType, statut: "CONFIRME",
});

// Le serveur signe désormais chaque billet (Ed25519) pour permettre une
// vérification hors-ligne fiable par les contrôleurs - on utilise toujours
// cette charge utile signée quand elle est disponible plutôt que d'en
// reconstruire une côté client (qui ne serait pas signée).
const getTicketQrPayload = (booking, passenger, trip, cls, tripType = "ALLER") =>
  booking?.qrPayload || buildQRPayload(booking, passenger, trip, cls, tripType);

/* ═══════════════════════════════════════
   OVERLAY
═══════════════════════════════════════ */
const Overlay = ({ onClose, children }) => (
  <div onClick={onClose} style={{ position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",padding:16 }}>
    <div onClick={e => e.stopPropagation()} style={{ width:"100%", maxWidth:560, maxHeight:"92vh", overflowY:"auto" }}>
      {children}
    </div>
  </div>
);

/* ═══════════════════════════════════════
   CITY AUTOCOMPLETE
═══════════════════════════════════════ */
const StationAutocomplete = ({ value, onChange, placeholder, stations }) => {
  const [open, setOpen]   = useState(false);
  const [query, setQuery] = useState(value || "");
  const ref = useRef(null);

  const filtered = query.length >= 1
    ? stations.filter(c => c.name.toLowerCase().includes(query.toLowerCase())).slice(0, 8)
    : stations.slice(0, 8);

  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const select = (s) => { setQuery(s.name); onChange(s); setOpen(false); };

  return (
    <div ref={ref} style={{ position:"relative" }}>
      <div style={s.inputWrap}>
        <span style={s.inputIcon}><MapPinIcon /></span>
        <input style={s.inputField} placeholder={placeholder} value={query}
          onChange={e => { setQuery(e.target.value); onChange(null); setOpen(true); }}
          onFocus={() => setOpen(true)} />
      </div>
      {open && filtered.length > 0 && (
        <div style={s.dropdown}>
          {filtered.map(c => (
            <div key={c.id} style={s.dropdownItem} className="dd-item" onMouseDown={() => select(c)}>
              <MapPinIcon /> <strong>{c.name}</strong>
              {c.stationCode && <span style={{ color:C.textSub, fontSize:11, marginLeft:6 }}>{c.stationCode}</span>}
            </div>
          ))}
        </div>
      )}
      <style>{`.dd-item:hover{background:${C.greenLt}!important;color:${C.green}!important}`}</style>
    </div>
  );
};

/* ═══════════════════════════════════════
   SEAT PICKER
═══════════════════════════════════════ */
const SeatPicker = ({ trip, passengerCount, onSelect, onClose, tripLabel }) => {
  const totalSeats = trip.totalSeats || 60;
  const taken      = trip.takenSeats || [];
  const [selected, setSelected] = useState([]);
  const [blockedSeat, setBlockedSeat] = useState(null);

  const cols = trip.travelClass === "VIP" ? 2 : 4;
  const rows = Math.ceil(totalSeats / cols);

  const handleClick = (n, isTaken) => {
    if (isTaken) {
      setBlockedSeat(n);
      setTimeout(() => setBlockedSeat(prev => prev === n ? null : prev), 3000);
      return;
    }
    setBlockedSeat(null);
    if (selected.includes(n)) {
      setSelected(selected.filter(x => x !== n));
    } else {
      setSelected(selected.length >= passengerCount ? [...selected.slice(1), n] : [...selected, n]);
    }
  };

  return (
    <Overlay onClose={onClose}>
      <div style={s.modal}>
        <div style={{ ...s.modalHeader, background:`linear-gradient(135deg,${C.greenDk},${C.green})` }}>
          <div>
            <div style={{ fontWeight:800, fontSize:15, color:"#fff" }}>Sélection des sièges</div>
            <div style={{ fontSize:11, color:"rgba(255,255,255,0.7)", marginTop:2 }}>
              {tripLabel && <span style={{ background:"rgba(255,255,255,0.2)", borderRadius:10, padding:"1px 8px", marginRight:6 }}>{tripLabel}</span>}
              {trip.departure?.name} → {trip.arrival?.name} · {trip.trainNumber} · {passengerCount} passager{passengerCount > 1 ? "s" : ""}
            </div>
          </div>
          <button style={{ background:"rgba(255,255,255,0.15)", border:"none", borderRadius:8, width:32, height:32, cursor:"pointer", color:"#fff", fontSize:16, display:"flex",alignItems:"center",justifyContent:"center" }} onClick={onClose}>✕</button>
        </div>

        <div style={{ padding:"20px 24px 24px" }}>
          <div style={{ minHeight:56, marginBottom:12, display:"flex", alignItems:"center", justifyContent:"center" }}>
            {blockedSeat ? (
              <div style={{ width:"100%", background:"#FEE2E2", border:"2px solid #EF4444", borderRadius:14, padding:"14px 20px", textAlign:"center" }}>
                <div style={{ fontWeight:800, fontSize:16, color:"#B91C1C", marginBottom:2 }}>Siège N°{blockedSeat} déjà occupé</div>
                <div style={{ fontSize:13, color:"#EF4444" }}>Veuillez choisir un autre siège disponible.</div>
              </div>
            ) : selected.length > 0 ? (
              <div style={{ width:"100%", background:`linear-gradient(135deg,${C.greenLt},#d4edda)`, border:`2px solid ${C.green}`, borderRadius:14, padding:"12px 20px", textAlign:"center" }}>
                <div style={{ fontWeight:800, fontSize:14, color:C.greenDk }}>
                  <CheckIcon /> {selected.length}/{passengerCount} siège{selected.length > 1 ? "s" : ""} sélectionné{selected.length > 1 ? "s" : ""} : {selected.join(", ")}
                </div>
              </div>
            ) : (
              <div style={{ fontSize:13, color:C.textSub, textAlign:"center" }}>
                Sélectionnez <strong style={{ color:C.green }}>{passengerCount} siège{passengerCount > 1 ? "s" : ""}</strong> disponible{passengerCount > 1 ? "s" : ""}
              </div>
            )}
          </div>

          <div style={{ background:"#F0F4F8", borderRadius:20, padding:"20px 16px", border:"1px solid #DDE3EA", marginBottom:20 }}>
            <div style={{ display:"flex", alignItems:"center", justifyContent:"center", gap:10, marginBottom:18 }}>
              <div style={{ flex:1, height:1, background:"linear-gradient(90deg,transparent,#ccc)" }} />
              <div style={{ background:C.greenDk, color:"#fff", borderRadius:20, padding:"5px 16px", fontSize:11, fontWeight:700, letterSpacing:1, display:"flex", alignItems:"center", gap:6 }}>
                <TrainIcon size={14} /> AVANT DU TRAIN
              </div>
              <div style={{ flex:1, height:1, background:"linear-gradient(90deg,#ccc,transparent)" }} />
            </div>

            <div style={{ display:"grid", gridTemplateColumns: cols === 2 ? "1fr 24px 1fr" : "1fr 1fr 24px 1fr 1fr", gap:"8px 6px", maxWidth:400, margin:"0 auto" }}>
              {Array.from({ length: rows }, (_, rowIdx) => {
                const leftSeats  = cols === 2 ? [rowIdx * 2 + 1] : [rowIdx * 4 + 1, rowIdx * 4 + 2];
                const rightSeats = cols === 2 ? [rowIdx * 2 + 2] : [rowIdx * 4 + 3, rowIdx * 4 + 4];
                return [...leftSeats, null, ...rightSeats].map((n, colIdx) => {
                  if (n === null) return <div key={`aisle-${rowIdx}`} />;
                  if (n > totalSeats) return <div key={`empty-${rowIdx}-${colIdx}`} />;
                  const isTaken   = taken.includes(n);
                  const isSel     = selected.includes(n);
                  const isBlocked = blockedSeat === n;
                  return (
                    <div key={n} onClick={() => handleClick(n, isTaken)}
                      title={isTaken ? `Siège ${n} - Occupé` : `Siège ${n} - Libre`}
                      style={{
                        position:"relative", borderRadius:10, height:52,
                        display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"flex-end", paddingBottom:6,
                        cursor: isTaken ? "not-allowed" : "pointer",
                        transition:"all 0.18s ease",
                        transform: isSel ? "translateY(-3px) scale(1.06)" : "scale(1)",
                        background: isTaken ? "#FFCDD2" : isSel ? C.green : "#FFFFFF",
                        border: `2px solid ${isTaken ? "#E57373" : isSel ? C.greenDk : isBlocked ? "#EF4444" : "#C8D0DA"}`,
                        boxShadow: isSel ? `0 6px 18px rgba(0,107,60,0.4)` : "none",
                      }}>
                      <div style={{ position:"absolute", top:0, left:4, right:4, height:10, borderRadius:"6px 6px 0 0", background: isTaken ? "#EF9A9A" : isSel ? "rgba(255,255,255,0.3)" : "#D0D8E0" }} />
                      <span style={{ fontWeight:800, fontSize:13, color: isTaken ? "#C62828" : isSel ? "#fff" : C.text, lineHeight:1, marginBottom:1 }}>
                        {isTaken ? "✕" : n}
                      </span>
                      {isSel && <span style={{ fontSize:9, color:"rgba(255,255,255,0.85)", fontWeight:600 }}>OK</span>}
                    </div>
                  );
                });
              })}
            </div>

            <div style={{ display:"flex", gap:20, justifyContent:"center", marginTop:18, flexWrap:"wrap" }}>
              {[
                { bg:"#fff", border:"#C8D0DA", label:"Libre" },
                { bg:C.green, border:C.greenDk, label:"Sélectionné" },
                { bg:"#FFCDD2", border:"#E57373", label:"Occupé" },
              ].map(({ bg, border, label }) => (
                <div key={label} style={{ display:"flex", alignItems:"center", gap:8 }}>
                  <div style={{ width:24, height:28, borderRadius:6, background:bg, border:`2px solid ${border}` }} />
                  <span style={{ fontSize:12, color:C.textSub, fontWeight:500 }}>{label}</span>
                </div>
              ))}
            </div>
          </div>

          <button style={{ ...s.btnPrimary, width:"100%", justifyContent:"center", opacity: selected.length === passengerCount ? 1 : 0.4, fontSize:15, padding:"13px 20px", borderRadius:12 }}
            disabled={selected.length !== passengerCount}
            onClick={() => onSelect(selected)}>
            Confirmer {selected.length === passengerCount ? `les sièges ${selected.join(", ")}` : `(${selected.length}/${passengerCount})`} →
          </button>
        </div>
      </div>
    </Overlay>
  );
};

/* ═══════════════════════════════════════
   PASSENGER MODAL
═══════════════════════════════════════ */
const PassengerModal = ({ trip, seatNumbers, onClose, onConfirm, tripLabel, tripType, showReturnNote, returnTripInfo }) => {
  const [passengers, setPassengers] = useState(seatNumbers.map(seat => ({ fullName: "", seatNumber: seat })));
  const [err, setErr] = useState("");
  const cls = CLASS_INFO[trip.travelClass] || CLASS_INFO.ECONOMIQUE;

  const updateName = (idx, val) => {
    const updated = [...passengers];
    updated[idx] = { ...updated[idx], fullName: val };
    setPassengers(updated);
    setErr("");
  };

  return (
    <Overlay onClose={onClose}>
      <div style={s.modal}>
        <div style={{ ...s.modalHeader, background:`linear-gradient(135deg,${C.greenDk},${C.green})` }}>
          <div>
            <div style={{ fontWeight:800, fontSize:15, color:"#fff" }}>Informations passagers</div>
            <div style={{ fontSize:11, color:"rgba(255,255,255,0.7)", marginTop:2 }}>
              {tripLabel && <span style={{ background:"rgba(255,255,255,0.2)", borderRadius:10, padding:"1px 8px", marginRight:6 }}>{tripLabel}</span>}
              {seatNumbers.length} passager{seatNumbers.length > 1 ? "s" : ""}
            </div>
          </div>
          <button style={{ background:"rgba(255,255,255,0.15)", border:"none", borderRadius:8, width:32, height:32, cursor:"pointer", color:"#fff", fontSize:16, display:"flex",alignItems:"center",justifyContent:"center" }} onClick={onClose}>✕</button>
        </div>
        <div style={{ padding:"20px 24px 24px" }}>
          {showReturnNote && (
            <div style={{ background:C.yellowLt, border:`1px solid ${C.yellow}`, borderRadius:10, padding:"10px 14px", marginBottom:16, fontSize:13, color:"#854D0E", display:"flex", alignItems:"center", gap:8 }}>
              <ReturnIcon size={14} />
              <span>Après l'aller, vous sélectionnerez ensuite les sièges pour le <strong>trajet retour</strong>.</span>
            </div>
          )}
          <div style={{ background:C.greenLt, borderRadius:12, padding:14, marginBottom:20, border:`1px solid ${C.grayBd}` }}>
            {[["Trajet", `${trip.departure?.name} → ${trip.arrival?.name}`],["Train", trip.trainNumber],["Départ", `${formatDateFR(trip.date)} à ${trip.departureTime}`]].map(([label, val]) => (
              <div key={label} style={{ display:"flex", justifyContent:"space-between", marginBottom:8 }}>
                <span style={{ fontSize:12, color:C.textSub }}>{label}</span>
                <span style={{ fontWeight:600, color:C.text }}>{val}</span>
              </div>
            ))}
            <div style={{ display:"flex", justifyContent:"space-between", marginBottom:8 }}>
              <span style={{ fontSize:12, color:C.textSub }}>Classe</span>
              <span style={{ background:cls.bg, color:cls.color, padding:"2px 10px", borderRadius:20, fontSize:12, fontWeight:600 }}>{cls.label}</span>
            </div>
            <div style={{ display:"flex", justifyContent:"space-between", borderTop:`1px dashed ${C.grayBd}`, paddingTop:10, marginTop:4 }}>
              <span style={{ fontSize:12, color:C.textSub }}>Total ({tripType})</span>
              <span style={{ fontWeight:800, fontSize:17, color:C.green }}>{(Number(trip.price) * seatNumbers.length).toLocaleString("fr-FR")} FCFA</span>
            </div>
            {returnTripInfo && (
              <div style={{ display:"flex", justifyContent:"space-between", paddingTop:8 }}>
                <span style={{ fontSize:12, color:C.textSub }}>Total (retour)</span>
                <span style={{ fontWeight:800, fontSize:17, color:"#854D0E" }}>{(Number(returnTripInfo.price) * seatNumbers.length).toLocaleString("fr-FR")} FCFA</span>
              </div>
            )}
          </div>
          {passengers.map((p, idx) => (
            <div key={idx} style={{ marginBottom:16, background:C.gray, borderRadius:10, padding:"12px 14px", border:`1px solid ${C.grayBd}` }}>
              <div style={{ fontSize:12, fontWeight:700, color:C.greenDk, marginBottom:8, display:"flex", alignItems:"center", gap:6 }}>
                <SeatIcon /> Passager {idx + 1} - Siège N°{p.seatNumber}
              </div>
              <label style={s.fieldLabel}>Nom complet *</label>
              <input style={s.inputField2} placeholder="Ex : Jean-Pierre Moussavou" value={p.fullName} onChange={e => updateName(idx, e.target.value)} />
            </div>
          ))}
          {err && <p style={{ color:"#ef4444", fontSize:12, marginTop:4 }}>{err}</p>}
          <button style={{ ...s.btnPrimary, width:"100%", marginTop:8, justifyContent:"center", fontSize:15, padding:"13px 20px", borderRadius:12 }}
            onClick={() => {
              const empty = passengers.find(p => !p.fullName.trim());
              if (empty) { setErr("Veuillez saisir le nom de tous les passagers"); return; }
              onConfirm(passengers);
            }}>
            Continuer →
          </button>
        </div>
      </div>
    </Overlay>
  );
};

/* ═══════════════════════════════════════
   PAYMENT MODAL
═══════════════════════════════════════ */
const OPERATORS = {
  "Airtel Money":   "074 000 000",
  "Moov Money":     "062 000 000",
  "Carte bancaire": "CB",
};

const PaymentModal = ({ bookings, trip, passengers, returnBookings, returnTrip, returnPassengers, isRoundTrip, onClose }) => {
  const [operator, setOperator] = useState("");
  const [txRef,    setTxRef]    = useState("");
  const [step,     setStep]     = useState(1);
  const [loading,  setLoading]  = useState(false);
  const [err,      setErr]      = useState("");
  const [downloadError, setDownloadError] = useState("");

  const isCB  = operator === "Carte bancaire";
  const clsAller  = CLASS_INFO[trip.travelClass] || CLASS_INFO.ECONOMIQUE;
  const clsRetour = returnTrip ? (CLASS_INFO[returnTrip.travelClass] || CLASS_INFO.ECONOMIQUE) : null;

  const totalAller  = Number(trip.price) * passengers.length;
  const totalRetour = returnTrip ? Number(returnTrip.price) * (returnPassengers?.length || passengers.length) : 0;
  const totalGlobal = totalAller + totalRetour;

  const handlePay = () => {
    if (!operator) { setErr("Choisissez un moyen de paiement"); return; }
    setStep(2); setErr("");
  };

  const handleVerify = async () => {
    if (!txRef.trim()) { setErr("Veuillez saisir le code reçu sur votre téléphone"); return; }
    setLoading(true);
    try {
      const allBookings = [...(bookings || []), ...(returnBookings || [])];
      await Promise.all(allBookings.map(b => {
        const bookingId = b.bookingId ?? b.id ?? b.booking?.id ?? null;
        if (!bookingId) throw new Error("ID manquant : " + JSON.stringify(b));
        return api.post("/verify-payment", { bookingId, transactionReference: txRef, operator, phoneNumber: isCB ? null : undefined });
      }));
      setStep(3);
    } catch (e) {
      setErr(e.response?.data?.error || e.message || "Code invalide ou paiement non trouvé.");
    } finally {
      setLoading(false);
    }
  };

  const [downloading, setDownloading] = useState(false);
  const handleDownloadPdf = async () => {
    setDownloading(true);
    setDownloadError("");
    try {
      const allTickets = [
        ...passengers.map((p, i) => ticketFromBooking(bookings[i], trip, p, "ALLER")),
        ...(returnPassengers || []).map((p, i) => ticketFromBooking((returnBookings||[])[i], returnTrip, p, "RETOUR")),
      ];
      await downloadTicketsPdf(allTickets, `billets-setrag-${bookings[0]?.reference || Date.now()}.pdf`);
    } catch (e) {
      setDownloadError("Échec du téléchargement : " + (e?.message || "erreur inconnue"));
    } finally {
      setDownloading(false);
    }
  };

  const handlePrint = async () => {
    const allTickets = [
      ...passengers.map((p, i) => ({ passenger: p, booking: bookings[i], trip, cls: clsAller, tripType: "ALLER" })),
      ...(returnPassengers || []).map((p, i) => ({ passenger: p, booking: (returnBookings||[])[i], trip: returnTrip, cls: clsRetour, tripType: "RETOUR" })),
    ];
    const ticketsWithQR = await Promise.all(allTickets.map(async (t) => {
      const payload = getTicketQrPayload(t.booking, t.passenger, t.trip, t.cls, t.tripType);
      const qrDataUrl = await buildQRDataURL(payload, 100);
      return { ...t, qrDataUrl };
    }));

    const ticketHTML = `<!DOCTYPE html><html lang="fr"><head><meta charset="UTF-8"/><title>Billets SETRAG</title>
      <style>*{box-sizing:border-box;margin:0;padding:0}body{font-family:'Segoe UI',sans-serif;background:#f0f0f0;padding:30px 20px}
      .ticket{background:#fff;border:2px solid #006B3C;border-radius:14px;overflow:hidden;max-width:520px;margin:0 auto 28px;box-shadow:0 4px 20px rgba(0,107,60,0.15)}
      .th{background:linear-gradient(135deg,#004D2B,#006B3C);padding:16px 22px;display:flex;justify-content:space-between;align-items:center}
      .logo{font-weight:900;font-size:18px;color:#fff}.ref{font-weight:800;font-size:12px;color:#fff;text-align:right}
      .badge{background:rgba(255,255,255,0.2);border-radius:12px;padding:2px 10px;font-size:10px;color:#fff;margin-top:4px;display:inline-block}
      .route{padding:18px 22px;border-bottom:1.5px dashed #e0e0e0;display:flex;justify-content:space-between;align-items:center}
      .st{font-weight:800;font-size:14px;color:#004D2B}.time{font-weight:900;font-size:26px;color:#006B3C}
      .info{padding:14px 22px;border-bottom:1.5px dashed #e0e0e0;display:grid;grid-template-columns:1fr 1fr;gap:10px}
      .il{font-size:9px;color:#666;letter-spacing:1px;margin-bottom:3px;text-transform:uppercase}.iv{font-weight:700;font-size:13px}
      .bottom{padding:14px 22px;background:#E8F5EE;display:flex;justify-content:space-between;align-items:center}
      .price{font-weight:900;font-size:26px;color:#006B3C}.qr-wrap{text-align:center}
      .qr-img{width:100px;height:100px;border:2px solid #004D2B;border-radius:6px;display:block}.qr-label{font-size:9px;color:#666;margin-top:4px}
      @media print{body{background:#fff;padding:0}.ticket{box-shadow:none;border-radius:0;max-width:100%;page-break-after:always}}</style></head><body>
      ${ticketsWithQR.map(({ passenger: p, booking: bk, trip: tr, cls, tripType, qrDataUrl }) => `
        <div class="ticket">
          <div class="th"><div><div class="logo">SETRAG</div><div style="font-size:10px;color:rgba(255,255,255,.65);margin-top:2px">TRANSGABONAIS</div>
          <div class="badge">${tripType === "RETOUR" ? "↩ BILLET RETOUR" : "→ BILLET ALLER"}</div>${isRoundTrip ? '<div class="badge">ALLER-RETOUR</div>' : ''}</div>
          <div class="ref"><div style="font-size:9px;color:rgba(255,255,255,.6)">BILLET OFFICIEL</div><div>${bk?.reference || ""}</div></div></div>
          <div class="route">
            <div><div style="font-size:9px;color:#666;letter-spacing:1px;margin-bottom:4px">DÉPART</div><div class="st">${tr.departure?.name}</div><div class="time">${tr.departureTime}</div></div>
            <div style="font-size:18px;color:#006B3C">→</div>
            <div style="text-align:right"><div style="font-size:9px;color:#666;letter-spacing:1px;margin-bottom:4px">ARRIVÉE</div><div class="st">${tr.arrival?.name}</div><div class="time">${tr.arrivalTime || "-"}</div></div>
          </div>
          <div class="info">
            <div style="grid-column:1/-1"><div class="il">PASSAGER</div><div class="iv" style="font-size:15px">${p.fullName}</div></div>
            <div><div class="il">DATE</div><div class="iv">${formatDateFR(tr.date)}</div></div>
            <div><div class="il">CLASSE</div><div class="iv">${cls.label}</div></div>
            <div><div class="il">SIÈGE</div><div class="iv" style="color:#006B3C">N°${p.seatNumber}</div></div>
            <div><div class="il">TRAIN</div><div class="iv">${tr.trainNumber}</div></div>
          </div>
          <div class="bottom">
            <div><div style="font-size:9px;color:#666;letter-spacing:1px;margin-bottom:2px">TARIF</div><div class="price">${Number(tr.price).toLocaleString("fr-FR")} <span style="font-size:13px">FCFA</span></div></div>
            <div class="qr-wrap"><img src="${qrDataUrl}" class="qr-img" alt="QR Code billet"/><div class="qr-label">Scanner pour vérifier</div></div>
          </div>
        </div>`).join("")}
      </body></html>`;

    const win = window.open("", "_blank", "width=640,height=900");
    win.document.write(ticketHTML);
    win.document.close();
    win.focus();
    setTimeout(() => win.print(), 500);
  };

  return (
    <Overlay onClose={step < 3 ? onClose : undefined}>
      <div style={s.modal}>
        <div style={{ ...s.modalHeader, background:`linear-gradient(135deg,${C.greenDk},${C.green})` }}>
          <div>
            <div style={{ fontWeight:800, fontSize:15, color:"#fff" }}>{step === 3 ? "Billets confirmés ✓" : "Paiement"}</div>
            {step < 3 && <div style={{ fontSize:11, color:"rgba(255,255,255,0.7)", marginTop:2 }}>{isRoundTrip ? "Paiement groupé aller + retour" : "Paiement billet aller"}</div>}
          </div>
          {step < 3 && <button style={{ background:"rgba(255,255,255,0.15)", border:"none", borderRadius:8, width:32, height:32, cursor:"pointer", color:"#fff", fontSize:16, display:"flex",alignItems:"center",justifyContent:"center" }} onClick={onClose}>✕</button>}
        </div>

        <div style={{ padding:"20px 24px 24px" }}>
          {step === 1 && (
            <>
              <div style={{ background:C.greenLt, borderRadius:12, padding:14, marginBottom:16, fontSize:13 }}>
                <div style={{ fontWeight:700, color:C.greenDk, marginBottom:8, display:"flex", alignItems:"center", gap:6 }}><ArrowIcon size={13} /> Trajet aller</div>
                <div style={{ color:C.textSub }}>{trip.departure?.name} → {trip.arrival?.name} · {formatDateFR(trip.date)} · {trip.departureTime}</div>
                <div style={{ color:C.textSub }}>Sièges : {passengers.map(p => p.seatNumber).join(", ")} · {passengers.length} passager{passengers.length > 1 ? "s" : ""}</div>
                <div style={{ fontWeight:700, color:C.green, marginTop:4 }}>{totalAller.toLocaleString("fr-FR")} FCFA</div>
              </div>
              {isRoundTrip && returnTrip && (
                <div style={{ background:C.yellowLt, border:`1px solid ${C.yellow}`, borderRadius:12, padding:14, marginBottom:16, fontSize:13 }}>
                  <div style={{ fontWeight:700, color:"#854D0E", marginBottom:8, display:"flex", alignItems:"center", gap:6 }}><ReturnIcon size={13} /> Trajet retour</div>
                  <div style={{ color:C.textSub }}>{returnTrip.departure?.name} → {returnTrip.arrival?.name} · {formatDateFR(returnTrip.date)} · {returnTrip.departureTime}</div>
                  <div style={{ color:C.textSub }}>Sièges : {(returnPassengers||[]).map(p => p.seatNumber).join(", ")} · {(returnPassengers||[]).length} passager{(returnPassengers||[]).length > 1 ? "s" : ""}</div>
                  <div style={{ fontWeight:700, color:"#854D0E", marginTop:4 }}>{totalRetour.toLocaleString("fr-FR")} FCFA</div>
                </div>
              )}
              <div style={{ background:"#fff", border:`2px solid ${C.green}`, borderRadius:12, padding:"12px 16px", marginBottom:20, display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                <span style={{ fontWeight:700, fontSize:14 }}>Total à payer</span>
                <span style={{ fontWeight:900, fontSize:22, color:C.green }}>{totalGlobal.toLocaleString("fr-FR")} FCFA</span>
              </div>
              <label style={s.fieldLabel}>Moyen de paiement</label>
              <div style={{ display:"flex", flexDirection:"column", gap:10, marginBottom:16 }}>
                {Object.keys(OPERATORS).map(op => (
                  <div key={op} onClick={() => { setOperator(op); setErr(""); }}
                    style={{ display:"flex", alignItems:"center", gap:12, padding:"12px 16px", borderRadius:12, border:`2px solid ${operator === op ? C.green : C.grayBd}`, background: operator === op ? C.greenLt : "#fff", cursor:"pointer", transition:"all 0.15s" }}>
                    <span style={{ fontSize:20, display:"flex" }}>{op === "Carte bancaire" ? <CrownIcon size={24} /> : <TicketIcon size={24} />}</span>
                    <div>
                      <div style={{ fontWeight:700, fontSize:14 }}>{op}</div>
                      <div style={{ fontSize:12, color:C.textSub }}>{op !== "Carte bancaire" ? `N° : ${OPERATORS[op]}` : "Visa / Mastercard"}</div>
                    </div>
                    {operator === op && <span style={{ marginLeft:"auto", color:C.green }}><CheckIcon /></span>}
                  </div>
                ))}
              </div>
              {operator && !isCB && <div style={{ background:C.yellowLt, border:`1px solid ${C.yellow}`, borderRadius:10, padding:12, marginBottom:16, fontSize:13 }}>Envoyez <strong>{totalGlobal.toLocaleString("fr-FR")} FCFA</strong> au numéro <strong>{OPERATORS[operator]}</strong> via <strong>{operator}</strong>. Vous recevrez un <strong>code de confirmation</strong> par SMS.</div>}
              {operator && isCB && <div style={{ background:C.yellowLt, border:`1px solid ${C.yellow}`, borderRadius:10, padding:12, marginBottom:16, fontSize:13 }}>Procédez au paiement de <strong>{totalGlobal.toLocaleString("fr-FR")} FCFA</strong> par carte bancaire. Un <strong>code de confirmation</strong> vous sera remis.</div>}
              {err && <p style={{ color:"#ef4444", fontSize:12, marginBottom:8 }}>{err}</p>}
              <button style={{ ...s.btnPrimary, width:"100%", justifyContent:"center", opacity: operator ? 1 : 0.45, fontSize:15, padding:"13px", borderRadius:12 }}
                disabled={!operator} onClick={handlePay}>J'ai effectué le paiement →</button>
            </>
          )}

          {step === 2 && (
            <>
              <div style={{ background:C.yellowLt, border:`1px solid ${C.yellow}`, borderRadius:12, padding:14, marginBottom:18, fontSize:13 }}>
                <div style={{ fontWeight:700, color:"#854D0E", marginBottom:4 }}>Saisissez le code reçu</div>
                <div style={{ color:C.textSub, lineHeight:1.6 }}>Entrez le code ou la référence reçu par SMS{!isCB ? ` ${operator}` : " bancaire"}. Ce code validera <strong>tous vos billets</strong> en une seule opération.</div>
              </div>
              <label style={s.fieldLabel}>Code de confirmation *</label>
              <input style={{ ...s.inputField2, fontSize:16, letterSpacing:1, fontWeight:600 }} placeholder="Saisir le code reçu..." value={txRef} autoFocus onChange={e => { setTxRef(e.target.value); setErr(""); }} />
              <div style={{ fontSize:11, color:C.textSub, marginTop:4 }}>Exemples : <em>123456</em>, <em>TRX-9A8B7C</em>, <em>MP240801XXXX</em>...</div>
              {err && <p style={{ color:"#ef4444", fontSize:12, marginTop:8 }}>{err}</p>}
              <div style={{ display:"flex", gap:10, marginTop:16 }}>
                <button style={{ ...s.btnSecondary, flex:1 }} onClick={() => setStep(1)}>← Retour</button>
                <button style={{ ...s.btnPrimary, flex:2, justifyContent:"center", opacity: txRef.trim() ? 1 : 0.45 }}
                  disabled={!txRef.trim() || loading} onClick={handleVerify}>{loading ? "Vérification..." : "Confirmer le paiement"}</button>
              </div>
            </>
          )}

          {step === 3 && (
            <>
              <InlineAlert type="success" title="Achat effectué">Votre achat a été effectué avec succès.</InlineAlert>
              <div style={{ textAlign:"center", marginBottom:20 }}>
                <div style={{ width:64, height:64, borderRadius:"50%", background:C.greenLt, border:`3px solid ${C.green}`, display:"flex", alignItems:"center", justifyContent:"center", margin:"0 auto 12px" }}>
                  <CheckIcon size={32} />
                </div>
                <h3 style={{ color:C.green, marginBottom:4, fontSize:18 }}>Réservation confirmée !</h3>
                <p style={{ color:C.textSub, fontSize:13 }}>{passengers.length} billet{passengers.length > 1 ? "s" : ""} aller{isRoundTrip ? ` + ${(returnPassengers||[]).length} billet${(returnPassengers||[]).length > 1 ? "s" : ""} retour` : ""} émis avec succès.</p>
              </div>
              {passengers.map((p, i) => (
                <TicketCard key={`aller-${i}`} passenger={p} booking={bookings[i]} trip={trip} cls={clsAller} tripType="ALLER"
                  qrPayload={getTicketQrPayload(bookings[i], p, trip, clsAller, "ALLER")} accentColor={C.green} label="→ Billet Aller" />
              ))}
              {isRoundTrip && returnTrip && (returnPassengers||[]).map((p, i) => (
                <TicketCard key={`retour-${i}`} passenger={p} booking={(returnBookings||[])[i]} trip={returnTrip} cls={clsRetour} tripType="RETOUR"
                  qrPayload={getTicketQrPayload((returnBookings||[])[i], p, returnTrip, clsRetour, "RETOUR")} accentColor="#854D0E" label="↩ Billet Retour" />
              ))}
              <p style={{ fontSize:12, color:"#999", textAlign:"center", marginBottom:16 }}>Présentez le QR code au contrôleur lors de l'embarquement.</p>
              {downloadError && (
                <InlineAlert type="error" title="Téléchargement impossible">{downloadError}</InlineAlert>
              )}
              <div style={{ display:"flex", gap:10 }}>
                <button style={{ ...s.btnSecondary, flex:1, justifyContent:"center" }} onClick={onClose}>Fermer</button>
                <button style={{ ...s.btnSecondary, flex:1, justifyContent:"center", gap:8 }} onClick={handlePrint}><PrintIcon /> Imprimer</button>
                <button style={{ ...s.btnPrimary, flex:1, justifyContent:"center", gap:8 }} disabled={downloading} onClick={handleDownloadPdf}>
                  {downloading ? "..." : <>⬇ Télécharger PDF</>}
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </Overlay>
  );
};

const TicketCard = ({ passenger, booking, trip, cls, tripType, qrPayload, accentColor, label }) => (
  <div style={{ background:"#fff", border:`2px solid ${accentColor}`, borderRadius:12, overflow:"hidden", marginBottom:12 }}>
    <div style={{ background:`linear-gradient(135deg,${C.greenDk},${accentColor === "#854D0E" ? "#a16207" : C.green})`, padding:"12px 18px", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
      <div>
        <div style={{ fontWeight:800, fontSize:14, color:"#fff" }}>SETRAG</div>
        <div style={{ fontSize:10, color:"rgba(255,255,255,.7)", marginTop:1 }}>{label}</div>
      </div>
      <div style={{ fontSize:12, fontWeight:700, color:"#fff" }}>{booking?.reference || ""}</div>
    </div>
    <div style={{ padding:"14px 18px", display:"grid", gridTemplateColumns:"1fr 1fr", gap:"10px 16px", fontSize:13 }}>
      <div style={{ gridColumn:"1/-1" }}><div style={{ fontSize:10, color:C.textSub, letterSpacing:1, marginBottom:2 }}>PASSAGER</div><div style={{ fontWeight:700, fontSize:15 }}>{passenger.fullName}</div></div>
      <div><div style={{ fontSize:10, color:C.textSub, letterSpacing:1 }}>TRAJET</div><div style={{ fontWeight:600 }}>{trip.departure?.name} → {trip.arrival?.name}</div></div>
      <div><div style={{ fontSize:10, color:C.textSub, letterSpacing:1 }}>DATE</div><div style={{ fontWeight:600 }}>{formatDateFR(trip.date)} {trip.departureTime}</div></div>
      <div><div style={{ fontSize:10, color:C.textSub, letterSpacing:1 }}>SIÈGE</div><div style={{ fontWeight:700, color:accentColor }}>N°{passenger.seatNumber}</div></div>
      <div><div style={{ fontSize:10, color:C.textSub, letterSpacing:1 }}>TRAIN</div><div style={{ fontWeight:600 }}>{trip.trainNumber}</div></div>
      <div><div style={{ fontSize:10, color:C.textSub, letterSpacing:1 }}>CLASSE</div><div style={{ fontWeight:600 }}>{cls.label}</div></div>
      <div><div style={{ fontSize:10, color:C.textSub, letterSpacing:1 }}>PRIX</div><div style={{ fontWeight:700 }}>{Number(trip.price).toLocaleString("fr-FR")} FCFA</div></div>
    </div>
    <div style={{ borderTop:`1px dashed ${C.grayBd}`, padding:"12px 18px", display:"flex", justifyContent:"center", background:C.greenLt }}>
      <div style={{ border:`2px solid ${C.green}`, borderRadius:8, padding:4, background:"#fff" }}>
        <QRCode data={qrPayload} size={100} />
      </div>
    </div>
  </div>
);

/* ═══════════════════════════════════════
   TOAST
═══════════════════════════════════════ */
// Les notifications passent par le système commun (components/Notify) :
// même style partout, empilement, fermeture et accessibilité.
/* ═══════════════════════════════════════
   CARTE MÉTRO
═══════════════════════════════════════ */
const STATIONS_LINE = [
  { name:"Libreville",    code:"LBV", km:0,   major:true,  terminus:true  },
  { name:"Owendo",        code:"OWD", km:15,  major:true,  terminus:false },
  { name:"Ntoum",         code:"NTM", km:49,  major:false, terminus:false },
  { name:"Bifoun",        code:"BIF", km:126, major:false, terminus:false },
  { name:"Lambaréné",     code:"LMB", km:253, major:true,  terminus:false },
  { name:"Lopé",          code:"LOP", km:374, major:true,  terminus:false },
  { name:"Booué",         code:"BOO", km:443, major:false, terminus:false },
  { name:"Lastoursville", code:"LST", km:536, major:false, terminus:false },
  { name:"Moanda",        code:"MOA", km:679, major:false, terminus:false },
  { name:"Franceville",   code:"FCV", km:740, major:true,  terminus:true  },
];

const MetroMap = () => {
  const [hovered, setHovered] = useState(null);
  const containerRef = useRef(null);
  const labelAbove = (i) => i % 2 === 0;

  return (
    <div style={{ background:"#fff", borderRadius:16, overflow:"hidden", boxShadow:"0 2px 16px rgba(0,0,0,0.07)", marginBottom:40, border:`1px solid ${C.grayBd}` }}>
      <div style={{ background:`linear-gradient(135deg, ${C.greenDk} 0%, ${C.green} 100%)`, padding:"14px 22px", display:"flex", alignItems:"center", justifyContent:"space-between" }}>
        <div style={{ display:"flex", alignItems:"center", gap:10 }}>
          <div style={{ width:32, height:32, borderRadius:"50%", background:"rgba(255,255,255,0.15)", display:"flex", alignItems:"center", justifyContent:"center" }}>
            <TrainIcon size={17} />
          </div>
          <div>
            <div style={{ fontWeight:800, fontSize:13, color:"#fff", letterSpacing:0.5 }}>LIGNE TRANSGABONAIS</div>
            <div style={{ fontSize:10, color:"rgba(255,255,255,0.65)", marginTop:1 }}>LIBREVILLE ↔ FRANCEVILLE · 740 km</div>
          </div>
        </div>
        <div style={{ fontSize:11, color:"rgba(255,255,255,0.55)", fontStyle:"italic" }}>Plan schématique</div>
      </div>

      <div ref={containerRef} style={{ overflowX:"auto", padding:"0 0 4px" }}>
        <div style={{ minWidth:660, padding:"32px 28px 20px", position:"relative" }}>
          <div style={{ position:"absolute", left:28, right:28, top:"calc(50% + 2px)", height:8, background:"rgba(0,0,0,0.06)", borderRadius:4 }} />
          <div style={{
            position:"absolute", left:28, right:28, top:"50%", transform:"translateY(-50%)",
            height:8, borderRadius:4,
            background:`linear-gradient(90deg, ${C.greenDk} 0%, ${C.green} 55%, #FFC300 100%)`,
          }} />
          <div style={{ position:"absolute", left:28, right:28, top:"50%", transform:"translateY(-50%)", height:8, borderRadius:4, overflow:"hidden", display:"flex", alignItems:"center" }}>
            {Array.from({ length: 48 }, (_, i) => (
              <div key={i} style={{ width:8, height:3, background:"rgba(255,255,255,0.22)", marginLeft:6, flexShrink:0, borderRadius:1 }} />
            ))}
          </div>
          <div style={{ position:"relative", height:160, display:"flex", alignItems:"center" }}>
            {STATIONS_LINE.map((st, i) => {
              const pct = (st.km / 740) * 100;
              const above = labelAbove(i);
              const isHov = hovered === st.code;
              const dotSize = st.major ? 18 : 12;
              const innerSize = st.terminus ? 6 : 0;

              return (
                <div
                  key={st.code}
                  onMouseEnter={() => setHovered(st.code)}
                  onMouseLeave={() => setHovered(null)}
                  style={{
                    position:"absolute",
                    left:`${pct}%`,
                    top:"50%",
                    transform:"translate(-50%, -50%)",
                    display:"flex",
                    flexDirection:"column",
                    alignItems:"center",
                    cursor:"pointer",
                    zIndex: isHov ? 10 : 2,
                  }}
                >
                  {above && (
                    <div style={{ marginBottom:6, textAlign:"center", paddingBottom:2, borderBottom: isHov ? `2px solid ${C.yellow}` : "2px solid transparent", transition:"border .15s" }}>
                      <div style={{ fontWeight: st.major ? 700 : 600, fontSize: st.major ? 11.5 : 10, color: isHov ? C.green : st.major ? C.greenDk : "#444", whiteSpace:"nowrap", transition:"color .15s" }}>
                        {st.name}
                      </div>
                      <div style={{ fontSize:9, color:C.textSub, fontWeight:600, letterSpacing:0.5 }}>{st.code}</div>
                      {isHov && (
                        <div style={{ fontSize:9, background:C.yellowLt, border:`1px solid ${C.yellow}`, borderRadius:4, padding:"1px 5px", marginTop:2, color:"#854D0E", fontWeight:600 }}>
                          km {st.km}
                        </div>
                      )}
                    </div>
                  )}

                  <div style={{
                    width: st.major ? 2 : 1.5,
                    height: above ? 14 : 14,
                    background: st.major ? C.greenDk : C.grayBd,
                    marginTop: above ? 0 : "auto",
                    marginBottom: above ? "auto" : 0,
                    order: above ? 0 : 2,
                    flexShrink:0,
                  }} />

                  <div style={{
                    width: dotSize,
                    height: dotSize,
                    borderRadius:"50%",
                    background: isHov ? C.yellow : st.terminus ? C.greenDk : "#fff",
                    border: `${st.major ? 3 : 2}px solid ${st.terminus ? C.greenDk : C.green}`,
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"center",
                    transition:"all 0.18s",
                    boxShadow: isHov ? `0 0 0 4px rgba(255,195,0,0.25)` : st.major ? "0 2px 6px rgba(0,0,0,0.15)" : "none",
                    flexShrink:0,
                    order:1,
                    zIndex:2,
                  }}>
                    {st.terminus && !isHov && (
                      <div style={{ width:innerSize, height:innerSize, borderRadius:"50%", background:"#fff" }} />
                    )}
                  </div>

                  <div style={{
                    width: st.major ? 2 : 1.5,
                    height:14,
                    background: st.major ? C.greenDk : C.grayBd,
                    order:2,
                    flexShrink:0,
                    opacity: above ? 0 : 1,
                  }} />

                  {!above && (
                    <div style={{ marginTop:6, textAlign:"center", paddingTop:2, borderTop: isHov ? `2px solid ${C.yellow}` : "2px solid transparent", transition:"border .15s", order:3 }}>
                      {isHov && (
                        <div style={{ fontSize:9, background:C.yellowLt, border:`1px solid ${C.yellow}`, borderRadius:4, padding:"1px 5px", marginBottom:2, color:"#854D0E", fontWeight:600 }}>
                          km {st.km}
                        </div>
                      )}
                      <div style={{ fontWeight: st.major ? 700 : 600, fontSize: st.major ? 11.5 : 10, color: isHov ? C.green : st.major ? C.greenDk : "#444", whiteSpace:"nowrap", transition:"color .15s" }}>
                        {st.name}
                      </div>
                      <div style={{ fontSize:9, color:C.textSub, fontWeight:600, letterSpacing:0.5 }}>{st.code}</div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <div style={{ borderTop:`1px solid ${C.grayBd}`, padding:"12px 22px", display:"flex", gap:24, flexWrap:"wrap", alignItems:"center", background:"#FAFAFA" }}>
        <div style={{ display:"flex", alignItems:"center", gap:7, fontSize:11.5, color:C.textSub }}>
          <div style={{ width:18, height:18, borderRadius:"50%", background:C.greenDk, border:`3px solid ${C.greenDk}`, display:"flex", alignItems:"center", justifyContent:"center" }}>
            <div style={{ width:5, height:5, borderRadius:"50%", background:"#fff" }} />
          </div>
          Terminus
        </div>
        <div style={{ display:"flex", alignItems:"center", gap:7, fontSize:11.5, color:C.textSub }}>
          <div style={{ width:18, height:18, borderRadius:"50%", background:"#fff", border:`3px solid ${C.green}` }} />
          Gare principale
        </div>
        <div style={{ display:"flex", alignItems:"center", gap:7, fontSize:11.5, color:C.textSub }}>
          <div style={{ width:12, height:12, borderRadius:"50%", background:"#fff", border:`2px solid ${C.green}` }} />
          Arrêt
        </div>
        <div style={{ marginLeft:"auto", fontSize:11, color:C.textSub, fontStyle:"italic" }}>
          Survolez une gare pour voir la distance
        </div>
      </div>
    </div>
  );
};

/* ═══════════════════════════════════════
   FILTRAGE DES TRAJETS DÉJÀ PARTIS
   Un trajet est encore réservable si sa date+heure de départ est dans le
   futur. On ne se contente pas de comparer la date (JJ/MM/AAAA) car un
   train du jour même mais déjà parti (ex: 08h00 alors qu'il est 14h00)
   ne doit plus être proposé.
═══════════════════════════════════════ */
const isTripDeparted = (trip) => {
  if (!trip?.date) return false; // pas de date connue -> on n'exclut pas par prudence
  try {
    const dt = new Date(`${trip.date}T${trip.departureTime || "00:00"}:00`);
    if (isNaN(dt.getTime())) return false;
    return dt.getTime() <= Date.now();
  } catch {
    return false;
  }
};

/* ═══════════════════════════════════════
   PAGE PRINCIPALE
═══════════════════════════════════════ */
/* ═══════════════════════════════════════
   ACTUALITÉS & PROMOTIONS
   Espace administrable (voir AdminNews.js côté staff) : actualités,
   annonces aux voyageurs et promotions publiées par SETRAG. N'affiche
   rien si l'admin n'a encore rien publié.
═══════════════════════════════════════ */
const NewsSection = () => {
  const [news, setNews] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get("/news").then(r => setNews(Array.isArray(r.data) ? r.data : [])).catch(() => {}).finally(() => setLoaded(true));
  }, []);

  if (!loaded || news.length === 0) return null;

  return (
    <div style={{ maxWidth:900, margin:"40px auto 0", padding:"0 16px" }}>
      <h2 style={{ textAlign:"center", fontSize:20, fontWeight:700, margin:"0 0 20px", color:C.greenDk }}>Actualités &amp; Promotions</h2>
      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(260px,1fr))", gap:16 }}>
        {news.slice(0, 6).map(n => (
          <div key={n.id} style={{ background:"#fff", border:`1px solid ${C.grayBd}`, borderRadius:14, overflow:"hidden", boxShadow:"0 2px 8px rgba(0,0,0,0.04)" }}>
            {n.imageUrl && <img src={n.imageUrl} alt={n.title} style={{ width:"100%", height:140, objectFit:"cover", display:"block" }} />}
            <div style={{ padding:16 }}>
              <div style={{ fontWeight:700, fontSize:14, marginBottom:6, color:C.text }}>{n.title}</div>
              <p style={{ fontSize:13, color:C.textSub, margin:0, lineHeight:1.6, whiteSpace:"pre-wrap" }}>{n.body}</p>
              <div style={{ fontSize:11, color:"#999", marginTop:10 }}>{formatDateFR(n.createdAt)}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default function Home() {
  const navigate = useNavigate();
  const { settings: siteSettings } = useSettings();

  const [stations,    setStations]    = useState([]);
  const [departure,   setDeparture]   = useState(null);
  const [arrival,     setArrival]     = useState(null);
  const [date,        setDate]        = useState("");
  const [returnDate,  setReturnDate]  = useState("");
  const [isRoundTrip, setIsRoundTrip] = useState(false);
  const [passengers,  setPassengers]  = useState(1);

  const [trips,       setTrips]       = useState([]);
  const [returnTrips, setReturnTrips] = useState([]);
  const [searched,    setSearched]    = useState(false);
  const [loading,     setLoading]     = useState(false);

  const [selectedTrip,   setSelectedTrip]   = useState(null);
  const [showSeatPicker, setShowSeatPicker] = useState(false);
  const [showPassenger,  setShowPassenger]  = useState(false);
  const [seatNumbers,    setSeatNumbers]    = useState([]);
  const [passInfo,       setPassInfo]       = useState(null);
  const [bookings,       setBookings]       = useState([]);

  const [selectedReturnTrip,   setSelectedReturnTrip]   = useState(null);
  const [showReturnSeatPicker, setShowReturnSeatPicker] = useState(false);
  const [returnSeatNumbers,    setReturnSeatNumbers]    = useState([]);
  const [returnPassInfo,       setReturnPassInfo]       = useState(null);
  const [returnBookings,       setReturnBookings]       = useState([]);

  const [showPayment, setShowPayment] = useState(false);
  const [showBuyConfirm, setShowBuyConfirm] = useState(false); // modale Bootstrap "confirmer l'achat"
  const [confirming, setConfirming] = useState(false);

  const showToast = useShowToast();

  useEffect(() => { api.get("/cities").then(r => setStations(r.data)).catch(() => {}); }, []);

  const handleSearch = async () => {
    if (!departure || !arrival) { showToast("Veuillez sélectionner la gare de départ et d'arrivée.", "warning"); return; }
    if (isRoundTrip && !returnDate) { showToast("Veuillez sélectionner une date de retour.", "warning"); return; }
    setLoading(true);
    try {
      const parseResp = (data) => {
        const match = data.match(/^\[[\s\S]*?\](?=\{|$)/);
        if (match) { try { return JSON.parse(match[0]); } catch {} }
        try { return JSON.parse(data); } catch {} return [];
      };
      const res = await api.get("/trips/search", { params: { departure: departure.name, destination: arrival.name, date }, transformResponse: [parseResp] });
      // On ne propose jamais un train dont le délai de départ est déjà dépassé
      // (date/heure de départ déjà passée), même si le backend le renvoie.
      setTrips(Array.isArray(res.data) ? res.data.filter(t => !isTripDeparted(t)) : []);
      if (isRoundTrip && returnDate) {
        const resReturn = await api.get("/trips/search", { params: { departure: arrival.name, destination: departure.name, date: returnDate }, transformResponse: [parseResp] });
        setReturnTrips(Array.isArray(resReturn.data) ? resReturn.data.filter(t => !isTripDeparted(t)) : []);
      } else { setReturnTrips([]); }
      setSearched(true);
      setSelectedTrip(null); setSelectedReturnTrip(null);
    } catch { showToast("Erreur lors de la recherche.", "error"); } finally { setLoading(false); }
  };

  // Aller-retour : les DEUX trajets sont choisis d'abord (aucun appel API tant
  // que l'achat n'est pas confirmé) - plus de réservation "en deux temps".
  const pickOutbound = (trip) => setSelectedTrip(trip);
  const pickReturn   = (trip) => setSelectedReturnTrip(trip);

  const canContinue = isRoundTrip ? (selectedTrip && selectedReturnTrip) : !!selectedTrip;
  const startSeatSelection = () => { if (canContinue) setShowSeatPicker(true); };

  const handleSeatsSelected = (seats) => {
    setSeatNumbers(seats);
    setShowSeatPicker(false);
    if (isRoundTrip) setShowReturnSeatPicker(true); // enchaîne directement sur les sièges retour
    else setShowPassenger(true);
  };

  const handleReturnSeatsSelected = (seats) => {
    setReturnSeatNumbers(seats);
    setShowReturnSeatPicker(false);
    setShowPassenger(true); // un seul formulaire passager pour les deux trajets
  };

  // Un seul formulaire passager (aller + retour) → ouvre la modale de
  // confirmation Bootstrap plutôt de réserver immédiatement.
  const handlePassengerConfirm = (passengerList) => {
    setPassInfo(passengerList);
    if (isRoundTrip) {
      setReturnPassInfo(passengerList.map((p, i) => ({ fullName: p.fullName, seatNumber: returnSeatNumbers[i] })));
    }
    setShowPassenger(false);
    setShowBuyConfirm(true);
  };

  // Création simultanée des billets aller (+ retour) après confirmation -
  // une seule opération, pas deux réservations successives.
  const confirmPurchase = async () => {
    setConfirming(true);
    try {
      const allerCalls = passInfo.map(p => api.post("/bookings", {
        tripId: selectedTrip.id, fullName: p.fullName, seatNumber: p.seatNumber, operator: "PENDING",
        tripType: "ALLER", isRoundTrip, returnDate: isRoundTrip ? returnDate : null,
      }));
      const calls = [...allerCalls];
      let retourStart = allerCalls.length;
      if (isRoundTrip) {
        calls.push(...returnPassInfo.map(p => api.post("/bookings", {
          tripId: selectedReturnTrip.id, fullName: p.fullName, seatNumber: p.seatNumber, operator: "PENDING",
          tripType: "RETOUR", isRoundTrip: true, returnDate,
        })));
      }
      const results = await Promise.all(calls);
      setBookings(results.slice(0, retourStart).map(r => r.data));
      if (isRoundTrip) setReturnBookings(results.slice(retourStart).map(r => r.data));
      setShowBuyConfirm(false);
      setShowPayment(true);
    } catch (e) {
      showToast(e.response?.data?.error || "La réservation n'a pas pu être créée. Réessayez.", "error");
    } finally {
      setConfirming(false);
    }
  };

  const resetAll = () => {
    setShowPayment(false); setSelectedTrip(null); setSelectedReturnTrip(null);
    setPassInfo(null); setReturnPassInfo(null); setBookings([]); setReturnBookings([]);
    setSeatNumbers([]); setReturnSeatNumbers([]);
  };
  const today = new Date().toISOString().split("T")[0];

  return (
    <div style={{ fontFamily:"'Segoe UI',sans-serif", color:C.text, minHeight:"100vh" }}>

      {/* ── NAVBAR ── */}
      <PublicNav />

      {/* ── HERO ── */}
      <div style={{ background:`linear-gradient(135deg,${C.greenDk} 0%,${C.green} 60%,#1E7A4A 100%)`, padding:"64px 24px 80px", textAlign:"center" }}>
        <div style={{ display:"inline-flex", alignItems:"center", gap:8, background:"rgba(255,255,255,0.15)", borderRadius:30, padding:"6px 16px", fontSize:12, color:"#fff", marginBottom:16, letterSpacing:1 }}>
          <FlagIcon size={14} /> SETRAG - Société d'Exploitation du Transgabonais
        </div>
        <h1 style={{ color:"#fff", fontSize:"clamp(28px,5vw,48px)", fontWeight:800, margin:"0 0 12px", lineHeight:1.2 }}>
          {siteSettings.heroTitle || "Réservez votre billet de train en ligne"}
        </h1>
        <p style={{ color:"rgba(255,255,255,0.85)", fontSize:16, maxWidth:500, margin:"0 auto 40px" }}>
          {siteSettings.heroSubtitle || "Voyagez à travers le Gabon en toute sérénité. Libreville, Lopé, Booué, Franceville et bien plus."}
        </p>

        <div style={{ background:"#fff", borderRadius:16, padding:"clamp(16px,4vw,24px)", maxWidth:820, margin:"0 auto", boxShadow:"0 20px 60px rgba(0,0,0,0.25)" }}>
          <div style={{ display:"flex", gap:8, marginBottom:20, justifyContent:"center" }}>
            {[false, true].map(rt => (
              <button key={String(rt)} onClick={() => { setIsRoundTrip(rt); if (!rt) setReturnDate(""); }}
                style={{ display:"inline-flex", alignItems:"center", gap:6, padding:"8px 20px", borderRadius:24, border:"2px solid", borderColor: isRoundTrip === rt ? C.green : C.grayBd, background: isRoundTrip === rt ? C.greenLt : "#fff", color: isRoundTrip === rt ? C.green : C.textSub, fontWeight:700, fontSize:13, cursor:"pointer", transition:"all 0.2s" }}>
                {rt ? <><ReturnIcon size={13} /> Aller-retour</> : <><ArrowIcon size={13} /> Aller simple</>}
              </button>
            ))}
          </div>
          {isRoundTrip && (
            <div style={{ background:C.greenLt, border:`1px solid ${C.green}`, borderRadius:10, padding:"10px 16px", marginBottom:16, fontSize:13, color:C.greenDk, display:"flex", alignItems:"center", gap:8 }}>
              <CheckIcon size={14} />
              <span>Réservation <strong>simplifiée</strong> : sièges aller → sièges retour → <strong>un seul paiement</strong> pour les deux trajets.</span>
            </div>
          )}
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(150px,1fr))", gap:12, alignItems:"end" }}>
            <div><label style={s.fieldLabel}>Gare de départ</label><StationAutocomplete value={departure?.name || ""} onChange={setDeparture} placeholder="Ex: Libreville" stations={stations} /></div>
            <div><label style={s.fieldLabel}>Gare d'arrivée</label><StationAutocomplete value={arrival?.name || ""} onChange={setArrival} placeholder="Ex: Franceville" stations={stations} /></div>
            <div>
              <label style={s.fieldLabel}>Date de départ</label>
              <div style={s.inputWrap}><span style={s.inputIcon}><CalIcon /></span><input style={s.inputField} type="date" value={date} min={today} onChange={e => setDate(e.target.value)} /></div>
              {date ? <div style={{ fontSize:11, color:C.textSub, marginTop:3 }}>{new Date(date+"T00:00:00").toLocaleDateString("fr-FR",{weekday:"long",day:"2-digit",month:"long"})}</div>
                    : <div style={{ fontSize:11, color:C.textSub, marginTop:3 }}>Format : JJ/MM/AAAA</div>}
            </div>
            {isRoundTrip && (
              <div>
                <label style={s.fieldLabel}>Date de retour</label>
                <div style={s.inputWrap}><span style={s.inputIcon}><ReturnIcon /></span><input style={s.inputField} type="date" value={returnDate} min={date || today} onChange={e => setReturnDate(e.target.value)} /></div>
                {returnDate ? <div style={{ fontSize:11, color:C.textSub, marginTop:3 }}>{new Date(returnDate+"T00:00:00").toLocaleDateString("fr-FR",{weekday:"long",day:"2-digit",month:"long"})}</div>
                            : <div style={{ fontSize:11, color:C.textSub, marginTop:3 }}>Format : JJ/MM/AAAA</div>}
              </div>
            )}
            <div>
              <label style={s.fieldLabel}>Passagers</label>
              <div style={{ ...s.inputWrap, justifyContent:"space-between", paddingRight:8 }}>
                <span style={s.inputIcon}><UsersIcon /></span>
                <span style={{ flex:1, fontSize:14, fontWeight:600 }}>{passengers} passager{passengers > 1 ? "s" : ""}</span>
                <div style={{ display:"flex", gap:4 }}>
                  <button onClick={() => setPassengers(p => Math.max(1, p-1))} style={{ width:28, height:28, borderRadius:8, border:`1.5px solid ${C.grayBd}`, background:"#fff", cursor:"pointer", fontWeight:700, fontSize:16, display:"flex", alignItems:"center", justifyContent:"center", color:C.text }}>−</button>
                  <button onClick={() => setPassengers(p => Math.min(9, p+1))} style={{ width:28, height:28, borderRadius:8, border:`1.5px solid ${C.green}`, background:C.greenLt, cursor:"pointer", fontWeight:700, fontSize:16, display:"flex", alignItems:"center", justifyContent:"center", color:C.green }}>+</button>
                </div>
              </div>
            </div>
            <button style={{ ...s.btnPrimary, height:46, width:"100%", justifyContent:"center", opacity: loading ? 0.75 : 1, cursor: loading ? "wait" : "pointer" }} onClick={handleSearch} disabled={loading}>
              {loading
                ? <><span style={{ width:15, height:15, border:"2px solid rgba(255,255,255,0.4)", borderTopColor:"#fff", borderRadius:"50%", display:"inline-block", animation:"setrag-spin 0.7s linear infinite" }} /> Recherche en cours…</>
                : <><SearchIcon /> Rechercher</>}
            </button>
            <style>{`@keyframes setrag-spin { to { transform: rotate(360deg); } }`}</style>
          </div>
        </div>
      </div>

      <NewsSection />

      {/* ── RÉSULTATS ── */}
      <div style={{ maxWidth:820, margin:"40px auto", padding:"0 16px" }}>
        {searched && (
          <>
            {isRoundTrip && (
              <div style={{ background:C.greenLt, border:`1px solid ${C.green}`, borderRadius:10, padding:"10px 16px", marginBottom:20, fontSize:13, color:C.greenDk, display:"flex", alignItems:"center", gap:8 }}>
                <CheckIcon size={14} />
                <span>Choisissez votre train <strong>aller</strong> et votre train <strong>retour</strong> ci-dessous, puis validez : les deux billets sont émis <strong>en une seule fois</strong>.</span>
              </div>
            )}
            <h2 style={{ fontSize:18, fontWeight:700, marginBottom:20 }}>
              {trips.length > 0 ? `${trips.length} voyage(s) disponible${trips.length > 1 ? "s" : ""} - ${departure?.name} → ${arrival?.name}` : "Aucun voyage disponible pour ce trajet"}
            </h2>
            {trips.length === 0 && (
              <div style={{ textAlign:"center", padding:40, color:C.textSub, background:"#fff", borderRadius:14, border:`1px solid ${C.grayBd}`, marginBottom:24 }}>
                <TrainIcon size={40} />
                <p style={{ marginTop:12, fontWeight:600, color:C.text }}>
                  {date === today ? "Tous les trains pour aujourd'hui sur ce trajet sont déjà partis." : "Aucun train disponible pour cette date."}
                </p>
                <p style={{ marginTop:4 }}>Essayez une autre date ou un autre trajet.</p>
              </div>
            )}
            {trips.map(trip => {
              const clsInfo = CLASS_INFO[trip.travelClass] || CLASS_INFO.ECONOMIQUE;
              const isChosen = selectedTrip?.id === trip.id;
              return (
                <div key={trip.id} style={{ ...s.tripCard, border:`1.5px solid ${isChosen ? C.green : C.grayBd}`, background: isChosen ? C.greenLt : "#fff" }}>
                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:12 }}>
                    <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                      <span style={{ background:clsInfo.bg, color:clsInfo.color, fontSize:12, fontWeight:600, padding:"3px 10px", borderRadius:20, display:"inline-flex", alignItems:"center", gap:4 }}>
                        <clsInfo.Icon size={14} /> {clsInfo.label}
                      </span>
                      <span style={{ fontSize:12, color:C.textSub, fontWeight:500, display:"inline-flex", alignItems:"center", gap:4 }}>
                        <TrainIcon size={13} /> {trip.trainNumber}
                      </span>
                    </div>
                    <span style={{ fontWeight:800, fontSize:20, color:C.green }}>{Number(trip.price).toLocaleString("fr-FR")} FCFA</span>
                  </div>
                  <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:12 }}>
                    <div style={{ textAlign:"center" }}><div style={{ fontWeight:700, fontSize:16 }}>{trip.departureTime}</div><div style={{ fontSize:12, color:C.textSub }}>{trip.departure?.name}</div></div>
                    <div style={{ flex:1, textAlign:"center" }}>
                      <div style={{ borderTop:`2px dashed ${C.grayBd}`, position:"relative" }}>
                        <span style={{ position:"absolute", top:-12, left:"50%", transform:"translateX(-50%)", background:"#fff", padding:"0 6px", display:"flex" }}><ArrowIcon size={20} /></span>
                      </div>
                    </div>
                    <div style={{ textAlign:"center" }}><div style={{ fontWeight:700, fontSize:16 }}>{trip.arrivalTime || "-"}</div><div style={{ fontSize:12, color:C.textSub }}>{trip.arrival?.name}</div></div>
                  </div>
                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap", gap:10 }}>
                    <div style={{ display:"flex", gap:16, fontSize:12, color:C.textSub }}>
                      <span style={{ display:"inline-flex", alignItems:"center", gap:4 }}><SeatIcon /> {trip.seats} places restantes</span>
                      <span style={{ display:"inline-flex", alignItems:"center", gap:4 }}><CalIcon /> {formatDateFR(trip.date)}</span>
                    </div>
                    <button style={{ ...s.btnPrimary, padding:"8px 20px", background: isChosen ? C.green : undefined }} onClick={() => pickOutbound(trip)}>
                      {isChosen ? "✓ Aller choisi" : isRoundTrip ? "Choisir ce train aller" : "Réserver"} <ArrowIcon size={14} />
                    </button>
                  </div>
                </div>
              );
            })}

            {isRoundTrip && (
              <>
                <h2 style={{ fontSize:18, fontWeight:700, margin:"32px 0 20px" }}>
                  {returnTrips.length > 0 ? `${returnTrips.length} voyage(s) retour - ${arrival?.name} → ${departure?.name}` : "Aucun voyage retour disponible pour cette date"}
                </h2>
                {returnTrips.length === 0 && (
                  <div style={{ textAlign:"center", padding:40, color:C.textSub, background:"#fff", borderRadius:14, border:`1px solid ${C.grayBd}` }}>
                    <TrainIcon size={40} />
                    <p style={{ marginTop:12, fontWeight:600, color:C.text }}>
                      {returnDate === today ? "Tous les trains retour pour aujourd'hui sont déjà partis." : "Aucun train retour disponible pour cette date."}
                    </p>
                    <p style={{ marginTop:4 }}>Essayez une autre date de retour.</p>
                  </div>
                )}
                {returnTrips.map(trip => {
                  const clsInfo = CLASS_INFO[trip.travelClass] || CLASS_INFO.ECONOMIQUE;
                  const isChosen = selectedReturnTrip?.id === trip.id;
                  return (
                    <div key={trip.id} style={{ ...s.tripCard, border:`1.5px solid ${isChosen ? "#854D0E" : C.yellow}`, background: isChosen ? C.yellowLt : "#FFFDF5" }}>
                      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:12 }}>
                        <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                          <span style={{ background:"#fff", color:"#854D0E", border:`1px solid ${C.yellow}`, fontSize:11, fontWeight:700, padding:"3px 10px", borderRadius:20, display:"inline-flex", alignItems:"center", gap:4 }}><ReturnIcon size={12} /> Trajet retour</span>
                          <span style={{ background:clsInfo.bg, color:clsInfo.color, fontSize:12, fontWeight:600, padding:"3px 10px", borderRadius:20, display:"inline-flex", alignItems:"center", gap:4 }}><clsInfo.Icon size={14} /> {clsInfo.label}</span>
                          <span style={{ fontSize:12, color:C.textSub }}>{trip.trainNumber}</span>
                        </div>
                        <span style={{ fontWeight:800, fontSize:20, color:C.green }}>{Number(trip.price).toLocaleString("fr-FR")} FCFA</span>
                      </div>
                      <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:12 }}>
                        <div style={{ textAlign:"center" }}><div style={{ fontWeight:700, fontSize:16 }}>{trip.departureTime}</div><div style={{ fontSize:12, color:C.textSub }}>{trip.departure?.name}</div></div>
                        <div style={{ flex:1, textAlign:"center" }}>
                          <div style={{ borderTop:`2px dashed ${C.yellow}`, position:"relative" }}>
                            <span style={{ position:"absolute", top:-12, left:"50%", transform:"translateX(-50%)", background:isChosen ? C.yellowLt : "#FFFDF5", padding:"0 6px", display:"flex" }}><ReturnIcon size={20} /></span>
                          </div>
                        </div>
                        <div style={{ textAlign:"center" }}><div style={{ fontWeight:700, fontSize:16 }}>{trip.arrivalTime || "-"}</div><div style={{ fontSize:12, color:C.textSub }}>{trip.arrival?.name}</div></div>
                      </div>
                      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap", gap:10 }}>
                        <div style={{ display:"flex", gap:16, fontSize:12, color:C.textSub }}>
                          <span style={{ display:"inline-flex", alignItems:"center", gap:4 }}><SeatIcon /> {trip.seats} places restantes</span>
                          <span style={{ display:"inline-flex", alignItems:"center", gap:4 }}><CalIcon /> {formatDateFR(trip.date)}</span>
                        </div>
                        <button style={{ ...s.btnPrimary, padding:"8px 20px", background: isChosen ? "#854D0E" : "#B8860B" }} onClick={() => pickReturn(trip)}>
                          {isChosen ? "✓ Retour choisi" : "Choisir ce train retour"} <ArrowIcon size={14} />
                        </button>
                      </div>
                    </div>
                  );
                })}
              </>
            )}
          </>
        )}

        {searched && canContinue && (
          <div style={{ position:"sticky", bottom:16, zIndex:20, display:"flex", justifyContent:"center", marginTop:24 }}>
            <button
              style={{ ...s.btnPrimary, borderRadius:30, padding:"14px 36px", fontSize:15, boxShadow:"0 10px 30px rgba(0,107,60,0.35)" }}
              onClick={startSeatSelection}
            >
              {isRoundTrip ? "Continuer - Choisir les sièges (aller + retour)" : "Continuer - Choisir mon siège"} <ArrowIcon size={16} />
            </button>
          </div>
        )}

        {!searched && (
          <>
            <h2 style={{ textAlign:"center", fontSize:22, fontWeight:700, margin:"0 0 24px", color:C.greenDk }}>La ligne Transgabonais</h2>
            <MetroMap />

            <h2 style={{ textAlign:"center", fontSize:22, fontWeight:700, margin:"0 0 24px", color:C.greenDk }}>Nos classes de voyage</h2>
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(200px,1fr))", gap:16, marginBottom:48 }}>
              {Object.entries(CLASS_INFO).map(([key, c]) => (
                <div key={key} style={{ background:c.bg, borderRadius:14, padding:24, border:`1.5px solid ${c.color}33`, textAlign:"center" }}>
                  <div style={{ color:c.color, display:"flex", justifyContent:"center", marginBottom:10 }}><c.Icon size={36} /></div>
                  <div style={{ fontWeight:700, fontSize:16, color:c.color, marginBottom:6 }}>{c.label}</div>
                  <div style={{ fontSize:12, color:C.textSub }}>
                    {key === "ECONOMIQUE" && "Confort standard, idéal pour les trajets réguliers"}
                    {key === "PREMIERE"   && "Sièges larges, plus d'espace, service amélioré"}
                    {key === "VIP"        && "Couchettes et compartiments privés pour les longs trajets"}
                  </div>
                </div>
              ))}
            </div>

            <h2 style={{ textAlign:"center", fontSize:22, fontWeight:700, margin:"0 0 24px", color:C.greenDk }}>Pourquoi voyager avec SETRAG ?</h2>
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(180px,1fr))", gap:16 }}>
              {[
                [TicketIcon, "Réservation en ligne","Achetez votre billet depuis n'importe où"],
                [TrainIcon,  "Mobile Money","Paiement facile par Airtel Money ou Moov Money"],
                [SeatIcon,   "Choix du siège","Sélectionnez votre siège selon vos préférences"],
              ].map(([Ic, title, desc]) => (
                <div key={title} style={{ background:C.greenLt, borderRadius:14, padding:20, textAlign:"center" }}>
                  <div style={{ color:C.green, display:"flex", justifyContent:"center", marginBottom:8 }}><Ic size={32} /></div>
                  <div style={{ fontWeight:700, fontSize:14, marginBottom:6 }}>{title}</div>
                  <div style={{ fontSize:12, color:C.textSub }}>{desc}</div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>

      {/* ── FOOTER ── */}
      <footer style={{ background:C.greenDk, color:"rgba(255,255,255,0.7)", padding:"48px 24px", marginTop:60 }}>
        <div style={{ maxWidth:900, margin:"0 auto", display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(220px,1fr))", gap:40 }}>
          <div>
            <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:10 }}>
              <TrainIcon size={20} />
              <span style={{ fontWeight:800, color:"#fff", fontSize:16 }}>SETRAG</span>
            </div>
            <p style={{ fontSize:13, margin:0, lineHeight:1.7 }}>Société d'Exploitation du Transgabonais - Votre partenaire de mobilité au Gabon depuis 1987.</p>
          </div>
          <div>
            <div style={{ fontWeight:700, color:"#fff", marginBottom:16 }}>Navigation</div>
            {[["Accueil","/"],["Tarifs","/tarifs"],["Véhicules","/vehicules"],["Marchandises","/marchandises"],["Contact","/contact"]].map(([label, path]) => (
              <div key={label} style={{ fontSize:13, marginBottom:12 }}>
                <a href={path} style={{ color:"rgba(255,255,255,0.7)", textDecoration:"none" }}>{label}</a>
              </div>
            ))}
          </div>
          <div>
            <div style={{ fontWeight:700, color:"#fff", marginBottom:16 }}>Contact</div>
            <div style={{ display:"flex", alignItems:"flex-start", gap:10, fontSize:13, marginBottom:12 }}>
              <div style={{ width:30, height:30, borderRadius:8, background:"rgba(255,255,255,0.1)", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0, marginTop:1 }}>
                <MapPinIcon size={15} color="rgba(255,255,255,0.75)" />
              </div>
              <span>Libreville, Gabon</span>
            </div>
            <div style={{ display:"flex", alignItems:"flex-start", gap:10, fontSize:13, marginBottom:12 }}>
              <div style={{ width:30, height:30, borderRadius:8, background:"rgba(255,255,255,0.1)", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0, marginTop:1 }}>
                <PhoneIcon size={15} color="rgba(255,255,255,0.75)" />
              </div>
              <a href="tel:+24101000000" style={{ color:"rgba(255,255,255,0.7)", textDecoration:"none" }}>+241 01 XX XX XX</a>
            </div>
            <div style={{ display:"flex", alignItems:"flex-start", gap:10, fontSize:13 }}>
              <div style={{ width:30, height:30, borderRadius:8, background:"rgba(255,255,255,0.1)", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0, marginTop:1 }}>
                <EmailIcon size={15} color="rgba(255,255,255,0.75)" />
              </div>
              <a href="mailto:contact@setrag.ga" style={{ color:"rgba(255,255,255,0.7)", textDecoration:"none" }}>contact@setrag.ga</a>
            </div>
          </div>
        </div>
        <div style={{ textAlign:"center", marginTop:40, fontSize:12, borderTop:"1px solid rgba(255,255,255,0.1)", paddingTop:20 }}>
          © {new Date().getFullYear()} SETRAG - Tous droits réservés
          <div style={{ marginTop:8, display:"flex", justifyContent:"center", gap:18 }}>
            <a href="/politique-de-confidentialite" style={{ color:"rgba(255,255,255,0.6)", textDecoration:"none" }}>Politique de confidentialité</a>
            <a href="/conditions-utilisation" style={{ color:"rgba(255,255,255,0.6)", textDecoration:"none" }}>Conditions d'utilisation</a>
          </div>
        </div>
      </footer>

      {/* ── MODALS ── */}
      {showSeatPicker && selectedTrip && (
        <SeatPicker trip={selectedTrip} passengerCount={passengers} tripLabel="Aller" onSelect={handleSeatsSelected} onClose={() => setShowSeatPicker(false)} />
      )}
      {showReturnSeatPicker && selectedReturnTrip && (
        <SeatPicker trip={selectedReturnTrip} passengerCount={passengers} tripLabel="Retour" onSelect={handleReturnSeatsSelected} onClose={() => setShowReturnSeatPicker(false)} />
      )}
      {showPassenger && selectedTrip && (
        <PassengerModal
          trip={selectedTrip} seatNumbers={seatNumbers} tripLabel={isRoundTrip ? "Aller + Retour" : "Aller"} tripType="aller"
          showReturnNote={false}
          returnTripInfo={isRoundTrip ? selectedReturnTrip : null}
          onClose={() => setShowPassenger(false)}
          onConfirm={handlePassengerConfirm}
        />
      )}

      {/* Confirmation d'achat - même style que toutes les boîtes de dialogue SETRAG */}
      {showBuyConfirm && passInfo && (
        <div className="ntf-backdrop" onMouseDown={e => { if (e.target === e.currentTarget && !confirming) setShowBuyConfirm(false); }}>
          <div className="ntf-dialog" role="alertdialog" aria-modal="true" aria-labelledby="buy-confirm-title" style={{ "--ntf-color": C.greenDk, "--ntf-bg": C.greenLt }}>
            <div className="ntf-dialog-head">
              <div className="ntf-dialog-ico"><CheckIcon size={22} /></div>
              <div className="ntf-dialog-title" id="buy-confirm-title">Confirmer votre achat</div>
            </div>
            <div className="ntf-dialog-msg">
              <p style={{ margin:"0 0 8px" }}>Émettre {isRoundTrip ? "les billets aller-retour" : "le billet"} pour :</p>
              <ul style={{ listStyle:"none", padding:0, margin:"0 0 10px", fontSize:13, color:"#5b6b63" }}>
                {passInfo.map((p, i) => <li key={i}>👤 {p.fullName} · siège N°{p.seatNumber}</li>)}
              </ul>
              <div style={{ border:"1.5px solid #e3dccb", borderRadius:10, padding:"8px 10px", marginBottom:8 }}>
                <div style={{ fontWeight:700, color: C.greenDk, fontSize:13 }}>→ Aller</div>
                <div style={{ fontSize:12.5, color:"#5b6b63" }}>{selectedTrip?.departure?.name} → {selectedTrip?.arrival?.name} · {formatDateFR(selectedTrip?.date)} · {selectedTrip?.departureTime}</div>
              </div>
              {isRoundTrip && selectedReturnTrip && (
                <div style={{ border:"1.5px solid #e3dccb", borderRadius:10, padding:"8px 10px", marginBottom:8 }}>
                  <div style={{ fontWeight:700, color:"#854D0E", fontSize:13 }}>↩ Retour</div>
                  <div style={{ fontSize:12.5, color:"#5b6b63" }}>{selectedReturnTrip.departure?.name} → {selectedReturnTrip.arrival?.name} · {formatDateFR(selectedReturnTrip.date)} · {selectedReturnTrip.departureTime}</div>
                </div>
              )}
              <p style={{ margin:"10px 0 0" }}>
                Montant total : <strong style={{ color: C.greenDk }}>
                  {(Number(selectedTrip?.price || 0) * passInfo.length + (isRoundTrip ? Number(selectedReturnTrip?.price || 0) * passInfo.length : 0)).toLocaleString("fr-FR")} FCFA
                </strong>
              </p>
            </div>
            <div className="ntf-dialog-actions">
              <button type="button" className="ntf-btn ntf-btn-ghost" onClick={() => setShowBuyConfirm(false)} disabled={confirming}>Annuler</button>
              <button type="button" className="ntf-btn ntf-btn-primary" onClick={confirmPurchase} disabled={confirming} autoFocus>
                {confirming ? "Traitement…" : "Confirmer l'achat"}
              </button>
            </div>
          </div>
        </div>
      )}

      {showPayment && bookings.length > 0 && selectedTrip && passInfo && (
        <PaymentModal bookings={bookings} trip={selectedTrip} passengers={passInfo} returnBookings={isRoundTrip ? returnBookings : []} returnTrip={isRoundTrip ? selectedReturnTrip : null} returnPassengers={isRoundTrip ? returnPassInfo : null} isRoundTrip={isRoundTrip && !!selectedReturnTrip} onClose={resetAll} />
      )}

    </div>
  );
}

const s = {
  inputWrap:   { display:"flex", alignItems:"center", border:`1.5px solid ${C.grayBd}`, borderRadius:10, background:"#fff", overflow:"hidden", height:46 },
  inputIcon:   { padding:"0 10px", color:C.textSub, display:"flex", alignItems:"center" },
  inputField:  { flex:1, border:"none", outline:"none", fontSize:14, padding:"0 10px 0 0", background:"transparent" },
  inputField2: { width:"100%", border:`1.5px solid ${C.grayBd}`, borderRadius:10, padding:"11px 14px", fontSize:14, outline:"none", boxSizing:"border-box" },
  dropdown:    { position:"absolute", top:"100%", left:0, right:0, background:"#fff", border:`1px solid ${C.grayBd}`, borderRadius:10, zIndex:200, boxShadow:"0 8px 24px rgba(0,0,0,0.1)", marginTop:4 },
  dropdownItem:{ padding:"10px 14px", fontSize:13, cursor:"pointer", display:"flex", alignItems:"center", gap:8 },
  btnPrimary:  { display:"inline-flex", alignItems:"center", gap:6, background:C.green, color:"#29963a", border:"none", borderRadius:10, padding:"11px 20px", fontWeight:700, cursor:"pointer", fontSize:14 },
  btnSecondary:{ display:"inline-flex", alignItems:"center", justifyContent:"center", gap:6, background:"#fff", color:C.text, border:`1.5px solid ${C.grayBd}`, borderRadius:10, padding:"11px 20px", fontWeight:600, cursor:"pointer", fontSize:14 },
  modal:       { background:"#fff", borderRadius:16, boxShadow:"0 20px 60px rgba(0,0,0,0.3)", overflow:"hidden" },
  modalHeader: { display:"flex", justifyContent:"space-between", alignItems:"center", padding:"16px 24px", borderBottom:`1px solid ${C.grayBd}` },
  fieldLabel:  { display:"block", fontSize:12, fontWeight:600, color:C.textSub, marginBottom:6, textTransform:"uppercase", letterSpacing:0.5 },
  tripCard:    { background:"#fff", border:`1.5px solid ${C.grayBd}`, borderRadius:14, padding:20, marginBottom:16, boxShadow:"0 2px 8px rgba(0,0,0,0.04)" },
};